import { render, staticRenderFns } from "./CGradientColor.vue?vue&type=template&id=12d87c65&scoped=true"
import script from "./CGradientColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CGradientColor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CGradientColor.vue?vue&type=style&index=0&id=12d87c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d87c65",
  null
  
)

export default component.exports